import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';

import { setPageHeaderTextActionCreator } from 'plugins/store/reducers/common.reducer';
import withStyles from '@material-ui/core/styles/withStyles';
import { getLicenseSettings, updateLicenseSettings } from 'services/license.service';

// components
import LicensingTable from './LicensingTable';
import SnackMessage from 'components/Snackbar/SnackMessage';
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import CardHeader from 'components/Card/CardHeader';
import CardIcon from 'components/Card/CardIcon';
import Button from 'components/CustomButtons/Button';
import { ReactComponent as LicensingIcon } from 'assets/img/Menu_Licensing.svg';

import styles from 'assets/jss/material-dashboard-pro-react/views/licensingStyles';

class Licensing extends Component {
	viewName = 'Licensing';

	state = {
		isLoading: false,
	};

	componentDidMount() {
		this.props.setPageHeaderText(this.viewName);
		this.getLicenseSettings();
	}

	componentWillUnmount() {
		this.props.setPageHeaderText('');
	}

	showToastMessage = (message, color = 'danger') => {
		this.props.enqueueSnackbar(message, {
			content: (key, message) => <SnackMessage id={key} message={message} color={color} />,
		});
	}

	getLicenseSettings = () => {
		this.fetchData(getLicenseSettings);
	}

	updateLicenseSettings = () => {
		this.fetchData(updateLicenseSettings);
	}

	fetchData = async (fn) => {
		this.setState({ isLoading: true });
		try {
			await fn();
		} catch (error) {
			this.showToastMessage(error.resolvedErrorMessage);
		}
		this.setState({ isLoading: false });
	}

	render() {
		const { classes } = this.props;
		const loadingIndicator = this.state.isLoading
			?	<div className={classes.loadingIndicatorWrapper}><LoadingIndicator /></div>
			: null;

		return (
			<GridContainer>
				<GridItem xs={12} sm={12} md={12}>
					<Card>
						<CardHeader color="primary" icon>
							<CardIcon color="primary">
								<LicensingIcon />
							</CardIcon>
						</CardHeader>
						<CardBody className={classes.wrapper}>
							<div className={classes.header}>
								<div className={classes.title}>
									Licenses
								</div>
								<Button
									size="sm"
									color="warning"
									onClick={this.updateLicenseSettings}
								>
									Get an update
								</Button>
							</div>
							{loadingIndicator}
							<div className={classes.licensingTable}>
								<LicensingTable />
							</div>
						</CardBody>
					</Card>
				</GridItem>
			</GridContainer>
		);
	}
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
	setPageHeaderText: bindActionCreators(
		setPageHeaderTextActionCreator,
		dispatch,
	),
});

export default compose(
	withStyles(styles),
	withSnackbar,
	connect(mapStateToProps, mapDispatchToProps),
)(Licensing);
